module.exports = __webpack_public_path__ + "img/2step-01-01-1_ergebnis.8d0690d3.webp";